/**
 * <s-today-hours> - Highlights today's row in an opening-hours list. Rows carry
 * data-day="monday".."sunday"; the matching row gets [data-today],
 * aria-current="date" and a light violet tint, and its .hours-today-tag (rendered
 * hidden with inline display:none) is shown. The day is read in the store's time
 * zone (data-timezone, default Europe/Brussels), in the browser, so it is right
 * for every visitor and never frozen into cached page HTML. Styles are set inline
 * so the result does not depend on stylesheet timing.
 */
class STodayHours extends HTMLElement {
  connectedCallback() {
    const timeZone = this.dataset.timezone || 'Europe/Brussels';
    let today;
    try {
      today = new Intl.DateTimeFormat('en-US', { weekday: 'long', timeZone }).format(new Date()).toLowerCase();
    } catch {
      return;
    }
    const tint = 'color-mix(in oklab, var(--color-accent) 14%, var(--color-surface))';
    for (const row of this.querySelectorAll('[data-day]')) {
      const isToday = row.dataset.day === today;
      const tag = row.querySelector('.hours-today-tag');
      row.toggleAttribute('data-today', isToday);
      row.style.backgroundColor = isToday ? tint : '';
      if (isToday) row.setAttribute('aria-current', 'date');
      else row.removeAttribute('aria-current');
      if (tag) tag.style.display = isToday ? 'inline' : 'none';
    }
  }
}

if (!customElements.get('s-today-hours')) customElements.define('s-today-hours', STodayHours);
